import React from "react";

const AssetsImg = ({ color }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 9.72168V15.4917C3 17.6117 3 17.6117 5 18.9617L10.5 22.1417C11.33 22.6217 12.68 22.6217 13.5 22.1417L19 18.9617C21 17.6117 21 17.6117 21 15.5017V9.72168C21 7.61168 21 7.61168 19 6.26168L13.5 3.08168C12.68 2.60168 11.33 2.60168 10.5 3.08168L5 6.26168C3 7.61168 3 7.61168 3 9.72168Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 15.6113C13.6569 15.6113 15 14.2682 15 12.6113C15 10.9544 13.6569 9.61133 12 9.61133C10.3431 9.61133 9 10.9544 9 12.6113C9 14.2682 10.3431 15.6113 12 15.6113Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AssetsImg;
